import defaultApi from './defaultApi';

const notifyApi = {
  notify: {
    prefix: process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings',
    SWAGGER: '/v2/api-docs?group=API-v1.0.0',
    API_INFO: {},
    SAMPLE: {},

    getNotifications() {
      return new Promise((resolve, reject) => {
        this.post('/system/v1/console/notifications', {}, false, true)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    },

    markNotificationAsRead(targetIds) {
      return new Promise((resolve, reject) => {
        this.post('/system/v1/console/notifications/update', targetIds, false, true)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    }
  }
};

notifyApi.notify = Object.assign(notifyApi.notify, defaultApi);

export default notifyApi;
